import React from "react";
import { connect } from "react-redux";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Badge,
} from "@material-ui/core";
import { createMuiTheme, withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSlidersH,
  faCalendarAlt,
  faCalendarCheck,
  faRoute,
  faMobileAlt,
  faEnvelopeOpenText,
  faUsers,
  faReceipt,
  faTasks,
  faDatabase,
  faMicrophoneAlt,
  faHandshake,
  faMapMarkerAlt,
  faPoll,
  faChartBar,
  faClipboardList,
  faUserTag,
  faCog,
  faTicketAlt,
  faLifeRing,
} from "@fortawesome/free-solid-svg-icons";
import { Logo } from "./Logo";
import { MenuIcon } from "./MenuIcon";
import classNames from "classnames";
import i18next from "i18next";
import { appActions, userActions } from "../_actions";
import { serverUrl, agrUrl, helpUrl, rentEnabled } from "../_constants";
import "../css/style.css";
import "../css/fonts.css";
import logoMark from "../img/logo-mark.svg";

// Иконки меню — векторные: либо фирменный знак (logo-mark.svg), либо иконки
// Font Awesome. Растровые PNG 24×24 на экранах с плотностью 3x растягивались
// втрое и выглядели мыльными (QA 08.26, №40).
const MENU_MARK = logoMark;
const ICON = {
  plus: faPlus,
  conf_param: faSlidersH,
  conf_prog: faCalendarAlt,
  nav: faRoute,
  client_view: faMobileAlt,
  mailings: faEnvelopeOpenText,
  confpartips: faUsers,
  partips: faUsers,
  orders: faReceipt,
  tasks: faTasks,
  bases: faDatabase,
  speakers: faMicrophoneAlt,
  sponsors: faHandshake,
  blds: faMapMarkerAlt,
  sites: faMapMarkerAlt,
  votes: faPoll,
  statistics: faChartBar,
  "anketa-fields": faClipboardList,
  team_org: faUsers,
  role_org: faUserTag,
  settings: faCog,
  tickets: faTicketAlt,
  new_site: faPlus,
  booking: faCalendarCheck,
  helpmenu: faLifeRing,
};

// img пункта меню — либо строка-URL (фирменный знак), либо ключ из ICON.
const menuIcon = (key) => ICON[key] || null;

const ACTIVE_COLOR = "#36B2F1";

const menu_superuser_data = [
  {
    page: "userlist",
    title: "Список пользователей",
    img: menuIcon("partips"),
    child: [],
  },
];
const menu_org_data = [
  {
    page: "confs_title",
    title: "Мероприятия",
    isHidden: true,
    img: "",
    child: [
      { page: "confs", title: "Все мероприятия", img: MENU_MARK },
      { page: "new_conf", title: "Новое мероприятие", img: menuIcon("plus") },
      ...(rentEnabled ? [{ page: "sites", title: "sites", img: menuIcon("sites") }] : []),
    ],
  },
  {
    page: "conf_param_main",
    title: "Редактор мероприятия",
    logoHidden: true,
    img: "",
    child: [
      { page: "conf_param", title: "Параметры мероприятия", img: menuIcon("conf_param") },
      { page: "conf_prog", title: "Конструктор", img: menuIcon("conf_prog") },
      { page: "nav", title: "Навигация", img: menuIcon("nav") },
      { page: "client_view", title: "Вид для клиента", img: menuIcon("client_view") },
      { page: "mailings", img: menuIcon("mailings"), child: [] },
      {
        page: "confpartips",
        title: "Участники мероприятия",
        img: menuIcon("confpartips"),
        child: [],
      },
      { page: "orders", title: "orders", img: menuIcon("orders") },
    ],
  },
  { page: "tasks", img: menuIcon("tasks"), child: [] },
  {
    page: "bases",
    title: "Базы",
    img: menuIcon("bases"),
    child: [
      { page: "speakers", title: "Спикеры", img: menuIcon("speakers") },
      { page: "sponsors", title: "Спонсоры", img: menuIcon("sponsors") },
      { page: "blds", title: "Площадки", img: menuIcon("blds") },
    ],
  },
  {
    page: "votes",
    title: "Опросы",
    img: menuIcon("votes"),
    child: [
      { page: "votelist", title: "votelist" },
      { page: "newvote", title: "add vote" },
    ],
  },
  {
    page: "partips",
    title: "Участники мероприятия",
    img: menuIcon("partips"),
    child: [],
  },
  {
    page: "statistics",
    title: "Статистика посещений",
    img: menuIcon("statistics"),
    child: [],
  },
  { page: "anketa-fields", img: menuIcon("anketa-fields"), child: [] },
  {
    page: "team_role",
    title: "Команда и роли",
    img: "",
    isHidden: true,
    child: [
      { page: "team_org", title: "Команда", img: menuIcon("team_org") },
      { page: "role_org", title: "Роли", img: menuIcon("role_org") },
    ],
  },
  { page: "settings", title: "Настройки", img: menuIcon("settings"), child: [] },
  {
    page: "helpmenu",
    title: "Помощь",
    img: menuIcon("helpmenu"),
    child: [
      { page: "helpinfo", title: "Руководство", img: "" },
      { page: "support", title: "Поддержка", img: "" },
      { page: "politics", title: "Политика конфиденциальности", img: "" },
    ],
  },
];

const menu_data_hide = [
  { page: "confs", title: "Все мероприятия", img: MENU_MARK },
  { page: "new_conf", title: "Новое мероприятие", img: menuIcon("plus") },
  { page: "conf_param", title: "Параметры мероприятия", img: menuIcon("conf_param") },
  { page: "conf_prog", title: "Конструктор", img: menuIcon("conf_prog") },
  { page: "nav", title: "Навигация", img: menuIcon("nav") },
  { page: "client_view", title: "Вид для клиента", img: menuIcon("client_view") },
  { page: "tasks", img: menuIcon("tasks"), child: [] },
  { page: "mailings", img: menuIcon("mailings"), child: [] },
  { page: "anketa-fields", img: menuIcon("anketa-fields"), child: [] },
  { page: "orders", title: "orders", img: menuIcon("orders") },
  { page: "speakers", title: "Спикеры", img: menuIcon("speakers") },
  { page: "sponsors", title: "Спонсоры", img: menuIcon("sponsors") },
  { page: "blds", title: "Площадки", img: menuIcon("blds") },
  { page: "partips", title: "Участники мероприятия", img: menuIcon("partips") },
  { page: "team_org", title: "Команда", img: menuIcon("team_org") },
  { page: "role_org", title: "Роли", img: menuIcon("role_org") },
  { page: "settings", title: "Настройки", img: menuIcon("settings") },
  {
    page: "helpmenu",
    title: "Помощь",
    img: menuIcon("helpmenu"),
    child: [],
  },
];

const menu_student_data = [
  {
    page: "confs_title",
    title: "Мероприятия",
    img: MENU_MARK,
    child: [],
  },
  {
    page: "tickets",
    title: "Билеты",
    img: menuIcon("tickets"),
    child: [],
  },
];

const menu_bld_data = [
  {
    page: "confs_title",
    title: "Площадки",
    isHidden: true,
    img: "",
    child: [
      { page: "confs", title: "Все площадки", img: MENU_MARK },
      { page: "new_site", title: "Новая площадка", img: menuIcon("new_site") },
      { page: "booking", title: "Бронирования", img: menuIcon("booking") },
    ],
  },
  { page: "settings", title: "Настройки", img: menuIcon("settings"), child: [] },
];

class AppMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: this.props.app.page, menu_data: [], userType: "" };
  }

  goTo = (path) => {
    this.props.dispatch(appActions.moveTo(path));
  };

  getActive = (text) => {
    const { menu_data } = this.state;

    for (let i = 0; i < menu_data.length; i++) {
      if (menu_data[i].page == text) {
        return text;
      }

      if (menu_data[i].child.length > 0) {
        for (let j = 0; j < menu_data[i].child.length; j++) {
          if (menu_data[i].child[j].page == text) {
            return menu_data[i].page;
          }
        }
      }
    }

    return "other";
  };

  setPage = (page) => {
    let id = 0;
    if (this.props.conf && this.props.conf.id && this.props.conf.id > 0)
      id = this.props.conf.id;

    const { classes, dispatch } = this.props;

    if (page == "politics") {
      window.open(agrUrl);
    } else if (page == "helpinfo") {
      window.open(helpUrl);
    } else if (page == "support") {
      //const emailTo = 'support@naviconf.com';
      //window.open(`mailto:${emailTo}`);
      dispatch(appActions.setpage("support"));
    } else if (page == "helpmenu") {
      window.open(helpUrl);
    } else if (page == "team_role") {
      dispatch(appActions.setpage("team_org"));
    } else if (page == "confs_title") {
      dispatch(appActions.setpage("confs"));
    } else if (page == "bases") {
      dispatch(appActions.setpage("speakers"));
    } else if (page == "new_conf") {
      dispatch(userActions.set_conf(null));
      dispatch(appActions.setpage(page));
    } else if (page == "conf_param_main") {
      //dispatch(userActions.set_conf_selected());
      //dispatch(appActions.setpage(page, id));
    } else if (
      id > 0 &&
      (page == "conf_prog" ||
        page == "nav" ||
        page == "client_view" ||
        page == "mailings")
    )
      dispatch(appActions.setpage(page, id));
    else dispatch(appActions.setpage(page));

    if (window.innerWidth <= 1400 && this.props.onClose) {
      this.props.onClose();
    }
  };

  showChild = (data) => {
    const self = this;
    const { classes, dispatch } = this.props;
    const { page, lang } = this.props.app;

    return (
      <ul className="header__sublist">
        {data.length > 0 &&
          data.map((item, index) => {
            let bgColor = "";

            if (page == item.page) bgColor = ACTIVE_COLOR;

            return (
              <li
                className={item.img ? "header__iconitem" : "header__subitem"}
                onClick={() => self.setPage(item.page)}
                key={index}
                style={{ backgroundColor: bgColor, borderRadius: 10 }}
              >
                {item.img && (
                  <a className="link-icon" style={{ paddingBottom: 5 }}>
                    <MenuIcon img={item.img} style={{ marginRight: 10 }} />
                    {i18next.t(item.page)}
                  </a>
                )}
                {!item.img && (
                  <a className="header__sublink">{i18next.t(item.page)}</a>
                )}
              </li>
            );
          })}
      </ul>
    );
  };

  static getDerivedStateFromProps(props, current_state) {
    if (props.userType != "" && current_state.userType != props.userType) {
      if (props.userType == "superuser")
        return { menu_data: [...menu_superuser_data], userType: "superuser" };
      if (props.userType == "org")
        return { menu_data: [...menu_org_data], userType: "org" };
      if (props.userType == "team_member")
        return { menu_data: [...menu_org_data], userType: "team_member" };
      if (props.userType == "student")
        return { menu_data: [...menu_student_data], userType: "student" };
      if (props.userType == "building")
        return { menu_data: [...menu_bld_data], userType: "building" };

      return null;
    }
    return null;
  }

  render() {
    const { page, lang } = this.props.app;

    const self = this;

    const { menu_data } = this.state;

    const { classes, dispatch, open, onOpen } = this.props;

    return (
      <div>
        <aside
          className={`sidebar${open ? "" : " sidebar--collapsed"}`}
          style={{ width: open ? 300 : 60, zIndex: 8999 }}
        >
          <div
            className="sidebar-top"
            style={{ justifyContent: open ? "start" : "center" }}
          >
            <div className="toggle" onClick={onOpen}>
              <span />
              <span />
              <span />
            </div>
            {open && <Logo />}
          </div>

          {!self.props.open && (
            <div className="sidebar-collapsed-scroll">
              <ul className="nav">
                {this.props.userType != "student" &&
                  menu_data_hide.map((item, index) => (
                    <li
                      key={index}
                      title={i18next.t(item.page)}
                      onClick={() => self.setPage(item.page)}
                      style={{ display: "flex", justifyContent: "center", padding: "8px 0" }}
                    >
                      <MenuIcon img={item.img} />
                    </li>
                  ))}

                {this.props.userType == "student" &&
                  menu_data.map((item, index) => (
                    <li
                      key={1000 + index}
                      title={i18next.t(item.page)}
                      onClick={() => self.setPage(item.page)}
                      style={{ display: "flex", justifyContent: "center", padding: "8px 0" }}
                    >
                      <MenuIcon img={item.img} />
                    </li>
                  ))}
              </ul>
            </div>
          )}

          <nav
            id="sidebar-nav"
            data-simplebar="init"
            style={!open ? { display: "none" } : undefined}
          >
            <div
              className="simplebar-content-wrapper"
              tabIndex="0"
              role="region"
              aria-label="scrollable content"
              style={{ height: "100%" }}
            >
              <div className="simplebar-content" style={{ padding: "0px" }}>
                <ul className="nav">
                  {self.props.open &&
                    menu_data &&
                    menu_data.length > 0 &&
                    menu_data.map((item, index) => {
                      let bgColor = "";
                      if (page == item.page) bgColor = ACTIVE_COLOR;

                      if (item.child.length > 0) {
                        return (
                          <li className="list-submenu" key={index}>
                            {!item.isHidden && (
                              <a
                                className="link-icon link-toggle-submenu open"
                                style={{ paddingBottom: 5 }}
                                onClick={() => self.setPage(item.page)}
                              >
                                <MenuIcon img={item.img} style={{ marginRight: 10 }} />
                                <span>{i18next.t(item.page)}</span>
                              </a>
                            )}
                            {self.showChild(item.child)}
                          </li>
                        );
                      }
                      return (
                        <li
                          style={{
                            backgroundColor: bgColor,
                            borderRadius: 10,
                          }}
                        >
                          <a
                            className="link-icon"
                            onClick={() => self.setPage(item.page)}
                          >
                            <MenuIcon img={item.img} style={{ marginRight: 10 }} />
                            {i18next.t(item.page)}
                          </a>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </nav>
        </aside>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, users, authentication } = state;
  const { user } = authentication;
  const { unresolvedAppealCount } = app;
  return {
    user,
    users,
    app,
  };
}

const connectedAppMenu = connect(mapStateToProps)(AppMenu);
export { connectedAppMenu as AppMenu };
